import { changeLocation } from 'ha/modules/URLLocationHandler';
import { RequestError } from '@ha/api/v2/errors';
import { Thunk } from 'ha/myredux/types';
import { Payload as RegisterPayload } from '@ha/api/v2/register';
import { GlobalState } from 'ha/types/store';
import { EventName, trackAudience } from 'ha/utils/unless';
import { updateHasEverLoggedIn } from 'ha/server/routers/ha/googleOptimize';

import { AuthType } from '../types';
import { AuthLogicActions } from './actions';
import { login } from './login';

export const registerRequest =
  (fields: RegisterPayload, nextUrl?: string): Thunk<GlobalState, void> =>
  (dispatch, getState, services) => {
    dispatch(AuthLogicActions.authStart());

    return services.apiV2
      .register(fields)
      .then(({ data }) => {
        trackAudience(EventName.PROFILE_MADE);
        updateHasEverLoggedIn();
        if (nextUrl) {
          // if redirect is happening, avoid unnecessary page rerendering by modifying auth state
          // it can also lead to error in firefox
          // (network requests done during redirect are aborted with an error, breaking loadable components)
          return dispatch(changeLocation(nextUrl));
        }

        dispatch(AuthLogicActions.authDone());

        return dispatch(login(data, AuthType.register));
      })
      .catch((err: RequestError) => {
        dispatch(AuthLogicActions.authFail());

        throw err;
      });
  };
